import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';

import ReferenceCardContent, { ReferenceCardProps } from './ReferenceCardContent';

const ReferenceCard = (props: ReferenceCardProps) => {
  return (
    <IntlErrorBoundary fallbackType="card" style={{ width: '100%' }}>
      <ReferenceCardContent {...props} />
    </IntlErrorBoundary>
  );
};

export default ReferenceCard;
